const reviewData = [
    {
        name: 'Priya Sharma',
        img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ9CxVj4X8A5wq-lIHIf_ExrB1WGilnreumcQ&usqp=CAU',
        date: '11 April 2023',
        rating: 4.5,
        reviewData: 'Great app, provide instant loan. I recommended  to all who want to get a group loan'
    },
    {
        name: 'Pragatika Pradhan',
        img: 'https://play-lh.googleusercontent.com/a-/ALV-UjX6mlfX1hmQnPXeAjSWr7R0wiKx-TXZSg48NstiKmKXfUMm=s32-rw',
        date: '7 September 2021',
        rating: 3,
        reviewData: 'did the final step and will give 5star after I get the money'
    },
    {
        name: 'Mohan Patel',
        img: "",
        date: '12 March 2023',
        rating: 4,
        reviewData: 'This is very good credit platform'
    },
    {
        name: 'Rakesh  Parihar',
        img: '',
        date: '1 Feb 2023',
        rating: 3.5,
        reviewData: 'App is good, but did not got response when we messaeg on support channel'
    },
    {
        name: 'Manju',
        img: '',
        date: '12 Feb 2023',
        rating: 4,
        reviewData: 'I am self employed woman and wanted loan to start a business and I got here a loan quickly. nice app'
    },
    {
        name: 'Sachin Mang',
        img: '',
        date: '30 Apr 2023',
        rating: 5,
        reviewData: 'good loan app thanks for your app'
    },
    {
        name: 'Dilshad Ahmed',
        img:'',
        date: '27 Apr 2023',
        rating: 4,
        reviewData: 'very good kosh app'
    },
    {
        name: 'Rahul S',
        img: '',
        date: '25 Apr 2023',
        rating: 3,
        reviewData: 'This app is for only group loan not an individual personal loan'
    },
    {
        name: 'Vuhan Rathor',
        img: '',
        date: '17 Apr 2023',
        rating: 5,
        reviewData: 'good'
    },
    {
        name: 'Aditya Chauhan',
        img: '',
        date: '10 Apr 2023',
        rating: 5,
        reviewData: 'Authentication and identity approval process is very good'
    },
    {
        name: 'Aahad Choudhary',
        img: '',
        date: '17 Mar 2023',
        rating: 4,
        reviewData: 'Very fast service this app'
    },
    {
        name: 'Jyoti Chavan',
        img: '',
        date: '12 Jan 2023',
        rating: 5,
        reviewData: 'This is the best online loan application process is to short loan get with in few minutes'
    },
    {
        name: 'Sunil Kumar',
        img:'',
        date: '20 March  2023',
        rating: 5,
        reviewData: 'very good and reliable app'
    },
    {
        name: 'Satyam Prasad',
        img:'',
        date: '1 Fev 2023',
        rating: 4,
        reviewData: 'good for intand help in bad situation and low interest'
    },
]
export default reviewData